import React from "react";
import { Typography } from "../Typography/Typography";

interface CheckboxInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  isRequired: boolean;
  errors?: string[];
}

export const CheckboxInput = React.forwardRef<HTMLInputElement, CheckboxInputProps>((props, ref) => {
  const { label, isRequired, errors, ...inputProps } = props;

  return (
    <div className="mt-4 flex w-full flex-row items-start">
      <input {...inputProps} className="mr-2 mt-1 rounded focus:shadow-focus-glow" type="checkbox" ref={ref} />
      <Typography className={errors?.length ? "text-red" : ""}>
        {props.label}
        {isRequired ? "*" : ""}
      </Typography>
      {/* {errors?.map((errMessage, idx) => {
        // TODO: if we need checkbox that has errors, implement this lol
        // currently untested which is why its commented out
        // return (
        //   <p key={idx} className="text-red">
        //     {errMessage}
        //   </p>
        // );
        return null
      })} */}
    </div>
  );
});

CheckboxInput.displayName = "CheckboxInput";
